import { Icon } from '@chakra-ui/react';

// SFDownload
export default function SFSquareArrowUp(props) {
  return (
    <Icon
      width={6}
      height={6}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M11.9922 14.4844C11.6562 14.4844 11.375 14.2031 11.375 13.875V5.85156L11.4219 4.67969L10.8906 5.23438L9.71094 6.5C9.60156 6.625 9.42969 6.6875 9.28125 6.6875C8.95312 6.6875 8.71875 6.45312 8.71875 6.13281C8.71875 5.96875 8.78125 5.84375 8.89844 5.72656L11.5391 3.17969C11.7031 3.02344 11.8359 2.96875 11.9922 2.96875C12.1562 2.96875 12.2891 3.02344 12.4453 3.17969L15.0859 5.72656C15.2031 5.84375 15.2734 5.96875 15.2734 6.13281C15.2734 6.45312 15.0234 6.6875 14.7031 6.6875C14.5469 6.6875 14.3906 6.625 14.2812 6.5L13.0938 5.23438L12.5703 4.67969L12.6172 5.85156V13.875C12.6172 14.2031 12.3281 14.4844 11.9922 14.4844ZM7.51562 20.6016C5.88281 20.6016 5.0625 19.7891 5.0625 18.1797V10.3828C5.0625 8.77344 5.88281 7.96094 7.51562 7.96094H9.86719V9.21875H7.53125C6.75 9.21875 6.32031 9.64062 6.32031 10.4531V18.1094C6.32031 18.9219 6.75 19.3438 7.53125 19.3438H16.4531C17.2266 19.3438 17.6719 18.9219 17.6719 18.1094V10.4531C17.6719 9.64062 17.2266 9.21875 16.4531 9.21875H14.125V7.96094H16.4766C18.1094 7.96094 18.9297 8.77344 18.9297 10.3828V18.1797C18.9297 19.7891 18.1094 20.6016 16.4766 20.6016H7.51562Z' />
    </Icon>
  );
}
